
<div class="app-wrap">
  <openApp v-if="openapp"></openApp>
  <openApp-popUp v-if="!msb1v1app" ref="popup"></openApp-popUp>
  <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
</div>
